<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_i"></a>PRAISE FOR<br/>
<strong>The Dangerous Lives of Altar Boys</strong></p>
<p class="noindent1">“Heartbreaking yet hilarious … By marrying the earnest to the ridiculous, Fuhrman captures the sublime intensity of adolescence.… This book … can be compared to many of the classic coming-of-age novels.”</p>
<p class="right"><em>—Publishers Weekly</em> (starred review)</p>
<p class="noindent1">“The freshness of Chris Fuhrman’s novel comes from his ability to squeeze out of a time of transition universal evocations of rebellion against growing up…. Fuhrman provides his story and characters with enough originality to keep the narrative clipping along and his reader totally absorbed.”</p>
<p class="right"><em>—Chicago Tribune</em></p>
<p class="noindent1">“Sad and beautiful… captures wonderfully the vulnerability and overdone cynicism of adolescence.… there is an edge to the irreverent humor in this book … distilling the mix of innocent and corrupt, sacred and profane … into a poetry of the quotidian.”</p>
<p class="right"><em>—Philadelphia Inquirer</em></p>
<p class="noindent1">“The moral of the story … has so much gravity and grace.… This is the real thing, writing done with everything on the line.… The death of Chris Fuhrman is an incalculable loss to this generation of writers. We should be glad to have his testimony.”</p>
<p class="right"><em>—Boston Globe</em></p>
<p class="noindent1">“The author’s real triumph lies in his ability to plumb wild young minds, to reveal the ardent, romantic hearts that beat within wisecracking boys. Their wild, unselfconscious beauty permeates the book…. We may never know what a loss [Chris Fuhrman’s death] was. Who knows how many other brilliant, beautiful, heartbreaking books he might have written?”</p>
<p class="right"><em>—Boston Book</em> Review</p>
<p class="noindent1">“Here’s a book for anyone who wants to be reminded, with humor and compassion, of what life was like, as Francis puts it, ‘back when things could still happen for the first time.’”</p>
<p class="right">—The <em>Atlanta Journal</em></p>
<p class="noindent1"><a id="page_ii"></a>“A rollicking story set at a Catholic school in Savannah, Georgia… develops a series of sometimes hilarious vignettes on rebellion. [The] antics are not mere games, but life-affirming acts of defiance.… Imaginative and delightful.”</p>
<p class="right">—Los <em>Angeles Reader</em></p>
<p class="noindent1">“Delightful debut… conceived with the most artfully humorous language.”</p>
<p class="right">—LIT: <em>Chicago’s Literary Supplement</em></p>
<p class="noindent1">“Fuhrman is especially successful in capturing the awkwardness of first love and the fierce, blind loyalties of pubescent boys.”</p>
<p class="right"><em>—Kirkus Reviews</em></p>
<p class="noindent1">“This book deserves many, many readers. … a memorable, funny, and poignant depiction of a glorious boyhood chased down and brutally terminated. … A story as odd, vivid, painful, splendid, and sad as adolescence itself.… Fuhrman’s posthumous debut invites wistful speculation about the sort of career which might have followed it.”</p>
<p class="right"><em>—Commonweal</em></p>
<p class="noindent1">“One of the most strikingly original novels of recent memory.”</p>
<p class="right"><em>—Creative Loafing</em></p>
<p class="noindent1">“Fuhrman’s only novel shows him to have been a writer of enormous talent and skill…. This novel… is a portrait of the real Savannah. Smart, funny and beautifully rendered, this book deserves a wide audience.”</p>
<p class="right"><em>—Knoxville Metro Pulse</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?045d3363